import {
    PURCHASE_POST_REQUEST,
    PURCHASE_POST_SUCCESS,
    PURCHASE_POST_FAIL,
    PURCHASE_LIST_REQUEST,
    PURCHASE_LIST_SUCCESS,
    PURCHASE_LIST_FAIL,
    PURCHASE_UPDATE_REQUEST,
    PURCHASE_UPDATE_SUCCESS,
    PURCHASE_UPDATE_FAIL,
    ITEM_GET_REQUEST,
    ITEM_GET_SUCCESS,
    ITEM_GET_FAIL,
    ITEM_UPDATE_REQUEST,
    ITEM_UPDATE_SUCCESS,
    ITEM_UPDATE_FAIL,
    TOKEN_CREATE_REQUEST,
    TOKEN_CREATE_SUCCESS,
    TOKEN_CREATE_FAIL,
    TOKEN_AUTHORIZATION_REQUEST,
    TOKEN_AUTHORIZATION_SUCCESS,
    TOKEN_AUTHORIZATION_FAIL
} from '../constants/purchaseConstants'

import { baseAxios } from '../jwtInterceptor'

//アカウント登録しているかどうかで
export const post_purchase = (formData) => async(dispatch) => {
    try{
        dispatch({type: PURCHASE_POST_REQUEST})
        const accountInfo = localStorage.getItem('accountInfo')
        const headers = { 'Content-Type': 'multipart/form-data' }
        if (accountInfo) {
            headers['Authorization'] = `Bearer ${JSON.parse(accountInfo).access}`
        }
        await baseAxios.post('/api/inventory/purchase/create/', formData, { headers }).then(
            (response) => {
                dispatch({ type: PURCHASE_POST_SUCCESS, payload: response['data'] })
            }
        )
    }catch(error){
        dispatch({type: PURCHASE_POST_FAIL,
            payload:error.response && error.response.data.message
            ? 
            error.response.data.message
            :
            error.message
        })
    }
}

//アカウントが存在する場合のpurchaseリストの取得
export const get_purchase_list = () => async(dispatch) => {
    dispatch({type:PURCHASE_LIST_REQUEST})
    baseAxios.defaults.headers.common["Authorization"] = `Bearer ${JSON.parse(localStorage.getItem('accountInfo')).access}`;
    await baseAxios.get(`/api/inventory/purchase/list`).then(
        (response) => {
            dispatch({
                type:PURCHASE_LIST_SUCCESS, payload:response['data']
            })
        }
    ).catch(
        (error) => {
            dispatch({
                type: PURCHASE_LIST_FAIL,
                payload:error.response && error.response.data.message
                ? 
                error.response.data.message
                :
                error.message
            })
        }
    )
}

//アカウントが存在しない場合のpurchaseリストの取得
export const not_account_purchase_list = (data) => async(dispatch) => {
    dispatch({type:PURCHASE_LIST_REQUEST})
    await baseAxios.get('/api/inventory/purchase/not_account',data).then(
        (response) => {
            dispatch({
                type: PURCHASE_LIST_SUCCESS, payload: response['data']
            })
        }
    ).catch(
        (error) => {
            dispatch({
                type: PURCHASE_LIST_FAIL,
                payload:error.response && error.response.data.message
                ? 
                error.response.data.message
                :
                error.message
            })
        }
    )
}

//買取が全て成立した場合のpurchaseのstateのアップデート
export const appraisal_success_update = (purchase) => async(dispatch) => {
    try{
        dispatch({type: PURCHASE_UPDATE_REQUEST})
        const data = {
            'purchase': purchase
        }
        await baseAxios.put('/api/inventory/purchase/success_update', data).then(
            (response) => {
                dispatch({type: PURCHASE_UPDATE_SUCCESS, payload: response['data']})
            }
        )
    }catch{
        (error) => {
            dispatch({
                type: PURCHASE_UPDATE_FAIL,
                payload:error.response && error.response.data.message
                ? 
                error.response.data.message
                :
                error.message
            })
        }
    }
}

//買取が成立しなかった場合
export const appraisal_unsuccess_update = (purchase) => async(dispatch) => {
    dispatch({type: PURCHASE_UPDATE_REQUEST})
    const data = {
        'purchase': purchase
    }
    baseAxios.put('/api/inventory/purchase/unsuccess_update', data).then(
        (response) => {
            dispatch({type: PURCHASE_UPDATE_SUCCESS, payload: response['data']})
        }
    ).catch(
        (error) => {
            dispatch({
                type: PURCHASE_UPDATE_FAIL,
                payload:error.response && error.response.data.message
                ? 
                error.response.data.message
                :
                error.message
            })
        }
    )
}

//アイテムの取得
export const get_item = (purchase) => async(dispatch) => {
    try{
        dispatch({type: ITEM_GET_REQUEST})
        const data = {
            'purchase': purchase
        }
        await baseAxios.get('/api/inventory/item/list', data).then(
            (response) => {
                dispatch({type: ITEM_GET_SUCCESS, payload: response['data']})
            }
        )
    }catch{
        (error) => {
            dispatch({
                type: ITEM_GET_FAIL,
                payload:error.response && error.response.data.message
                ? 
                error.response.data.message
                :
                error.message
            })
        }
    }
}

//全てのアイテムの買取が成立した場合のitemのupdate
export const item_success_update = (data) => async(dispatch) => {
    try{
        dispatch({type: ITEM_UPDATE_REQUEST})
        await baseAxios.put('/api/inventory/item/success_update', data).then(
            (response) => {
                dispatch({ type: ITEM_UPDATE_SUCCESS, payload: response['data']})
            }
        )
    }catch{
        (error) => {
            dispatch({
                type: ITEM_UPDATE_FAIL,
                payload:error.response && error.response.data.message
                ? 
                error.response.data.message
                :
                error.message
            })
        }
    }

}

//全てのアイテムではないが買取が成立した場合のupdate
export const item_update = (data) => async(dispatch) => {
    try{
        dispatch({type: ITEM_UPDATE_REQUEST})
        await baseAxios.put('/api/inventory/item/update', data).then(
            (response) => {
                dispatch({type: ITEM_UPDATE_SUCCESS, payload: response['data']})
            }
        )
    }catch{
        (error) => {
            dispatch({
                type: ITEM_UPDATE_FAIL,
                payload:error.response && error.response.data.message
                ? 
                error.response.data.message
                :
                error.message
            })
        }
    }
}

//tokenの作成と取得api
export const token_create = (data) => async(dispatch) => {
    try{
        dispatch({type: TOKEN_CREATE_REQUEST})
        await baseAxios.post('/api/inventory/token_create', data).then(
            (response) => {
                dispatch({type: TOKEN_CREATE_SUCCESS, payload: response['data']})
            }
        )
    }catch{
        (error) => {
            dispatch({
                type: TOKEN_CREATE_FAIL,
                payload:error.response && error.response.data.message
                ? 
                error.response.data.message
                :
                error.message
            })
        }
    }
}

//tokenの認証
export const token_authorization = (data) => async(dispatch) => {
    try{
        dispatch({type: TOKEN_AUTHORIZATION_REQUEST})
        await baseAxios.post('/api/inventory/token_authorization', data).then(
            (response) => {
                dispatch({type: TOKEN_AUTHORIZATION_SUCCESS, payload: response['data']})
            }
        )
    }catch{
        (error) => {
            dispatch({
                type: TOKEN_AUTHORIZATION_FAIL,
                payload:error.response && error.response.data.message
                ? 
                error.response.data.message
                :
                error.message
            })
        }
    }
}
